var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"blk-cta",attrs:{"block":"","squared":""}},[_vm._v("\n  "+_vm._s(_vm.ctaText)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }